// Mapping of numeric component type IDs to string names
const COMPONENT_TYPE_MAP: Record<number | string, string> = {
  0: "Engine",
  1: "APU",
  2: "Landing Gear",
  // Also support string values
  "Engine": "Engine",
  "APU": "APU",
  "Landing Gear": "Landing Gear",
  "LandingGear": "Landing Gear",
};

export const getComponentTypeName = (componentType: number | string | undefined): string | undefined => {
  if (componentType === undefined || componentType === null) {
    return undefined;
  }

  const mapped = COMPONENT_TYPE_MAP[componentType];
  if (!mapped) {
    return undefined;
  }

  return mapped;
};

export const isValidComponentType = (componentType: any): boolean => {
  const validTypes = ["Engine", "APU", "Landing Gear"];
  return validTypes.includes(componentType);
};
